// Shared infrastructure constants for the promo update mutation. Lives in state/
// rather than under the PromoCodeInput component so state/hooks.ts can import them
// without inverting the component/state dependency direction (per design-system
// layering: state owns infrastructure, components consume it).

// Minimum visible duration for the in-flight skeleton on the summary rows
// (TotalAmountPayable, Money rows, installment schedule). The promo apply/clear flow
// makes one round-trip, so on fast responses the skeleton flashes off in <50ms.
// Holding the loading state for at least this many ms makes the state change
// perceptible without slowing down the apply itself — `useDelayedLoading` wraps the
// mutation's `isLoading` and keeps the skeleton up for the remainder of the window.
export const MIN_LOADING_DURATION_MS = 400

// Shared RTK Query cache key for the promo update mutation, scoped per checkout
// token. All call sites that need to subscribe to the same in-flight state
// (PromoCodeInput as trigger; summary hooks as readers) must compute the same key
// from the same token. Token-scoping isolates loading state across checkout sessions
// so stale `isLoading: true` from a previous token can't bleed into a new one if a
// user navigates between sessions without a page reload.
// See: https://redux-toolkit.js.org/rtk-query/api/created-api/hooks#sharing-results-between-mutation-hook-instances
export const promoMutationCacheKey = (token: string): string => `promo-${token}`
